
import infoIcon from '../../../../../images/icons/icon-info-outline.svg';
interface InfoIconProps {
	setShowTooltip: any;
	setPageX: any;
	setPageY: any;
}

export default function InfoIcon(props: InfoIconProps): JSX.Element {
	const { setShowTooltip, setPageX, setPageY } = props;
	return (
		<img
			onMouseOver={(e: any) => { setShowTooltip(true); setPageX(e.pageX); setPageY(e.pageY); }}
			onMouseLeave={() => { setShowTooltip(false); }}
			src={infoIcon}
			className="info-icon"
			alt="info-icon"
		/>
	);
}

